import { ErrorPage } from '@components/ErrorPage'
import { useGetLocaleFrom404 } from '@hooks/useGetLocaleFrom404'

export function NotFoundPage() {
  const { locale, language } = useGetLocaleFrom404()

  return <ErrorPage locale={locale} language={language} code='404' />
}
